import CommonModal from "../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import { closeModal } from "../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { useModalSelector } from "../../../../hooks/useModalSelector";
import { IMenusList } from "../../types";
import MenuForm from "../form/MenuForm";

interface IMenuFormModalProps {
  menus: IMenusList[];
  selectedMenu: IMenusList | null;
}

const MenuFormModal = ({ menus, selectedMenu }: IMenuFormModalProps) => {
  const dispatch = useAppDispatch();
  const { isOpen } = useModalSelector();

  const handleClose = () => dispatch(closeModal());

  return (
    <CommonModal
      headerClassName="bg-primary"
      titleClassName="text-white"
      title={selectedMenu ? "Edit Menu" : "Add Menu"}
      modalBodyClassName="ps-lg-4"
      centered
      fade
      backdrop="static"
      toggle={handleClose}
      isOpen={isOpen}
      showFooter={false}
    >
      <MenuForm
        dispatch={dispatch}
        menus={menus}
        selectedMenu={selectedMenu}
      />
    </CommonModal>
  );
};

export default MenuFormModal;
